export enum CommonStep {
  GET_STARTED = '',
}

export enum UserOnboardingStep {
  PROFILE = 'profile',
  PASSWORD = 'password',
  TOS = 'review-tos',
  APP = 'link-app',
}

export enum OrgOnboardingStep {
  FIND_BROKERAGE = 'find',
  CONTACT_SALES = 'contact',
  CLAIM_BROKERAGE = 'claim',
  REQUEST_APPROVAL = 'request-approval',
  VERIFY_UNLICENSED = 'verify',
  PRIMARY_ROLE = 'role',
  FIND_MEMBER = 'member',
  CLAIMED_PROFILE = '',
}

export enum ClaimPrefix {
  USER_PROFILE = '/join_brokerage/:hash',
  ORG_SELECT = '/org/select_brokerage/:hash',
  ORG_PROFILE = '/org/claim_brokerage/:hash',
  ORG_USER_PROFILE = '/org/claim_brokerage/:hash/claim_user/:userHash',
}

export const SHOW_WELCOME_URL_PARAM = 'showWelcome';

export const SUBMITTER_USER_ID_PARAM = 'submitterUserId';

/** Current onboarding stage. An org will typically progress from CLAIM -> WIZARD -> INTERNAL -> READY_TO_LAUNCH */
export enum StageName {
  CLAIM = 'CLAIM',
  WIZARD = 'WIZARD',
  INTERNAL = 'INTERNAL',
  READY_TO_LAUNCH = 'READY_TO_LAUNCH',
}

export enum OrgStatus {
  UNCLAIMED = 'UNCLAIMED',
  ONBOARDING = 'ONBOARDING',
  ACTIVE = 'ACTIVE',
}

export const ORG_STATUS_ORDER: Record<OrgStatus, number> = {
  UNCLAIMED: 0,
  ONBOARDING: 1,
  ACTIVE: 1,
};

export const STAGE_ORDER: Record<StageName, number> = {
  CLAIM: 0,
  WIZARD: 1,
  INTERNAL: 2,
  READY_TO_LAUNCH: 3,
};
